// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ranking-header[data-v-1e7230a3]{display:flex;flex-direction:column}@media(max-width:985px){.ranking-header__title[data-v-1e7230a3]{margin-bottom:8px}}@media(min-width:986px){.ranking-header__title[data-v-1e7230a3]{margin-bottom:16px}}.ranking-header__filter[data-v-1e7230a3]{height:48px;margin:0 -20px}.ranking-header__caption[data-v-1e7230a3]{color:#868e96;margin-top:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
